module.exports = __webpack_public_path__ + "static/media/ReactGitHubUserCardApp.cd296467.png";